import { TranslationKeys } from '../../types/Translations.type';
export class ErrorPresentationRenderer {
    constructor(assetViewerView, lowQualityPreviewUrl, previewDimensions) {
        this.assetViewerView = assetViewerView;
        this.lowQualityPreviewUrl = lowQualityPreviewUrl;
        this.previewDimensions = previewDimensions;
        this.container = null;
        this.image = null;
        this.isLoading = false;
        this.isActive = false;
    }
    get hasMetaData() {
        return true;
    }
    get dimensions() {
        return this.previewDimensions ? this.previewDimensions : { width: 400, height: 300 };
    }
    get url() {
        return this.assetViewerView.assetViewerItem.downloadUrl;
    }
    get translations() {
        return this.assetViewerView.config.TRANSLATIONS;
    }
    get previewUrl() {
        return this.lowQualityPreviewUrl ? this.lowQualityPreviewUrl : this.assetViewerView.assetViewerItem.previewUrl;
    }
    load() {
        return Promise.resolve();
    }
    get errorMessage() {
        if (!navigator.onLine) {
            return this.translations[TranslationKeys.RenderErrorWhenOffline];
        }
        if (!this.lowQualityPreviewUrl) {
            return this.translations[TranslationKeys.RenderErrorNoLowQualityPreview];
        }
        return this.translations[TranslationKeys.RenderError];
    }
    render(container) {
        this.container = container;
        return Promise.resolve().then(() => {
            const placeholder = document.createElement('div');
            const wrapper = document.createElement('div');
            const message = document.createElement('div');
            message.classList.add('error-message');
            message.style.padding = this.lowQualityPreviewUrl ? '6px 20px' : '15px 20px';
            message.innerHTML = this.errorMessage;
            wrapper.appendChild(message);
            placeholder.style.width = '100%';
            placeholder.style.height = '100%';
            placeholder.style.backgroundImage = this.previewUrl ? `url(${this.previewUrl})` : '';
            placeholder.style.backgroundRepeat = 'no-repeat';
            placeholder.style.backgroundPosition = 'center';
            placeholder.style.backgroundSize = 'contain';
            placeholder.style.webkitFilter = this.lowQualityPreviewUrl ? 'none' : 'blur(20px)';
            placeholder.style.transform = this.lowQualityPreviewUrl ? 'none' : 'scale(1.2)';
            if (!this.assetViewerView.isWindowsDesktopApp) {
                if (this.assetViewerView.assetViewerItem.isDownloadable !== false && !this.lowQualityPreviewUrl) {
                    const link = document.createElement('div');
                    link.classList.add('button-download');
                    link.innerHTML = this.translations[TranslationKeys.Download];
                    link.onclick = () => {
                        this.assetViewerView.download();
                    };
                    wrapper.appendChild(link);
                }
                if (this.assetViewerView.assetViewerItem.isDownloadable !== false && this.lowQualityPreviewUrl) {
                    const link = document.createElement('a');
                    link.innerHTML = this.translations[TranslationKeys.Download];
                    link.onclick = () => {
                        this.assetViewerView.download();
                    };
                    message.appendChild(link);
                    const closeButton = document.createElement('button');
                    closeButton.classList.add('error-message-close-button');
                    closeButton.innerHTML = '✕';
                    message.appendChild(closeButton);
                    closeButton.onclick = () => {
                        wrapper.removeChild(message);
                    };
                }
            }
            wrapper.appendChild(placeholder);
            wrapper.classList.add('error-presentation-wrapper');
            container.appendChild(wrapper);
        });
    }
    destroy() {
        if (this.container) {
            this.container.innerHTML = '';
            this.container = null;
        }
    }
    destroyFinal() {
        this.destroy();
    }
}
//# sourceMappingURL=ErrorPresentationRenderer.js.map